module.exports = __webpack_public_path__ + "img/fixed.7a4f52fd.png";